import { render, staticRenderFns } from "./ExercisesTab.vue?vue&type=template&id=4194871a&scoped=true"
import script from "./ExercisesTab.vue?vue&type=script&lang=js"
export * from "./ExercisesTab.vue?vue&type=script&lang=js"
import style0 from "./ExercisesTab.vue?vue&type=style&index=0&id=4194871a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4194871a",
  null
  
)

export default component.exports